<template>
  <div class="list-page common-bg" >
    <van-nav-bar fixed title="" left-text="" left-arrow @click-left="onClickLeft" safe-area-inset-top style="background-color: #1e1f24;">
        <template #title>
            <div class="nav-class">
                <van-dropdown-menu active-color="#fff" style="background-color: transparent; border: none;">
                    <van-dropdown-item v-model="gameType" :title="gameTxt" ref="tabsItem">
                        <template #default>
                            <div class="game-tabs flex-c-e">
                                <div v-for="(item, index) in gameTbas" :key="index" @click="changGameType(item.type, index)" :class="item.checked ? 'active' : ''" class="tab">
                                    <img :src="item.icon" class="tab-icon" />
                                    <div>{{ item.name }}</div>
                                </div>
                            </div>
                        </template>
                    </van-dropdown-item>
                </van-dropdown-menu>
            </div>
        </template>
    </van-nav-bar>
    <div style="height: 46px"></div>
    <!-- 左侧主游戏选项卡 + 右侧子游戏 -->
    <div class="game-category-box" v-if="currentTabs.length > 0">
      <div class="game-category-layout">
        <div class="game-sidebar">
          <div class="sidebar-item" v-for="(item, index) in currentTabs" :key="index" :class="{ active: activeTabIndex === index }" @click="switchTab(index)">
            <template v-if="item.is_all">
              <span>{{ item.name }}</span>
            </template>
            <template v-else>
              <img v-if="item.api_logo_img" :src="item.api_logo_img" class="sidebar-icon" />
              <span>{{ item.name }}</span>
            </template>
          </div>
        </div>
        <div class="game-content">
          <div class="game-grid">
            <div class="game-card" v-for="(item, idx) in currentSubGames" :key="idx" @click="$parent.openGamePage(item.platform_name, item.game_code, '')">
              <img :src="item.mobile_img" @error="handleImageError($event)" />
              <img class="game-card-collect" :src="item.is_favorite ? '/static/newImg/index/game/btn_collect_ok.avif' : '/static/newImg/index/game/btn_collect_wait.avif'" @click.stop="toggleFavorite(item)" />
              <span class="game-card-name" v-if="!item.mobile_img_has_text"><img class="game-card-head" :src="item.api_logo_img" /> {{ item.game_name }}</span>
              <span class="game-card-label" v-if="item.tag && !item.mobile_img_has_text">{{ item.tag }}</span>
            </div>
          </div>
          <div class="empty-tip" v-if="currentSubGames.length === 0">暂无游戏</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'gameList',
  data () {
    return {
        gameType: '0',
        gameTxt: '真人',
        activeTabIndex: 0,
        // URL ?type=X (0热门 1真人 2捕鱼 3电子 4彩票 5体育 6棋牌 7电竞 8区块链) → gameTbas.type
        urlTypeMap: {
            '0': '8', // 热门
            '1': '0', // 真人
            '2': '6', // 捕鱼
            '3': '4', // 电子
            '4': '5', // 彩票
            '5': '1', // 体育
            '6': '3', // 棋牌
            '7': '2', // 电竞
            '8': '7', // 区块链
        },
        // gameTbas.type → URL ?type=X 反向（调接口时用）
        tbas2Url: {
            '8': '0', '0': '1', '6': '2', '4': '3', '5': '4',
            '1': '5', '3': '6', '2': '7', '7': '8',
        },
        // 真人0 体育1 电竞2 棋牌3 电子4 彩票5 捕鱼6 区块链7 热门8 试玩9 最近10 收藏11
        gameTbas: [
            {name: '热门', type: '8', icon: '/static/newImg/index/game/icon_dtfl_1.avif', checked: false},
            {name: '电子', type: '4', icon: '/static/newImg/index/game/icon_dtfl_2.avif', checked: false},
            {name: '棋牌', type: '3', icon: '/static/newImg/index/game/icon_dtfl_3.avif', checked: false},
            {name: '捕鱼', type: '6', icon: '/static/newImg/index/game/icon_dtfl_4.avif', checked: false},
            {name: '真人', type: '0', icon: '/static/newImg/index/game/icon_dtfl_5.avif', checked: false},
            {name: '区块链',type: '7', icon: '/static/newImg/index/game/icon_dtfl_6.avif', checked: false},
            {name: '体育', type: '1', icon: '/static/newImg/index/game/icon_dtfl_7.avif', checked: false},
            {name: '彩票', type: '5', icon: '/static/newImg/index/game/icon_dtfl_8.avif', checked: false},
            // {name: '电竞', type: '2', icon: '/static/image/index/menu/menu_14.avif', checked: false},
            // {name: '试玩', type: '9', icon: '/static/image/index/menu/menu_15.avif', checked: false},
            {name: '最近', type: '10', icon: '/static/image/index/menu/menu_21.avif', checked: false},
            {name: '收藏', type: '11', icon: '/static/image/index/menu/menu_22.avif', checked: false},
        ],
        // ===== 真实数据（category_new接口返回） =====
        realData: {
            tabs: [],
            main_games: [],
            sub_games: {},
        },
    }
  },
  computed: {
    currentTabs() {
      return this.realData.tabs || [];
    },
    currentSubGames() {
      const tabs = this.currentTabs;
      if (tabs.length === 0) return [];
      const tab = tabs[this.activeTabIndex];
      if (!tab) return [];
      // Tab0（汇总）右侧：主游戏卡片列表（每个平台一张主游戏）
      if (tab.is_all) {
        return this.realData.main_games || [];
      }
      // Tab1~N（各平台）右侧：该平台子游戏列表
      const subs = this.realData.sub_games || {};
      return subs[tab.platform_name] || [];
    }
  },
  created () {
    var query = this.$route.query;
    if(query.type){
        let mappedType = this.urlTypeMap[query.type] || '0';
        this.gameType = mappedType;
        let tab = this.gameTbas.find(item => item.type == mappedType);
        this.gameTxt = tab ? tab.name : '真人';
        this.gameTbas.forEach(item => {
            item.checked = item.type == mappedType;
        });
    } else {
        this.gameTbas.forEach(item => {
            item.checked = item.type == this.gameType;
        });
    }
    this.activeTabIndex = 0;
    this.loadGameCategory();
  },
  methods: {
    loadGameCategory() {
      const gt = this.gameType;
      // 最近/收藏 本地处理，暂不请求
      if (gt === '10' || gt === '11') {
        this.realData = { tabs: [], main_games: [], sub_games: {} };
        return;
      }
      const urlType = parseInt(this.tbas2Url[gt] || '1');
      this.$apiFun.get('/api/game/category_new', { type: urlType }).then(res => {
        if (res.code === 200) {
          this.realData = {
            tabs:       res.data.tabs       || [],
            main_games: res.data.main_games || [],
            sub_games:  res.data.sub_games  || {},
          };
          this.activeTabIndex = 0;
        }
      });
    },
    switchTab(index) {
      this.activeTabIndex = index;
    },
    changGameType(type, i) {
      this.gameType = type;
      this.activeTabIndex = 0;
      this.gameTxt = this.gameTbas.find(item => item.type == type).name
      this.$refs.tabsItem.toggle();
      this.gameTbas.map((item, index) => {
            item.checked = index === i ? true : false;
     });
      this.loadGameCategory();
    },
    onClickLeft() {
      this.$router.back();
    },
    handleImageError(event) {
      event.target.src = '/static/image/errorImage.jpg';
    },
    toggleFavorite(item) {
      let that = this;
      // 未登录拦截：提示"请先登录"
      let token = sessionStorage.getItem('token') || (that.$store && that.$store.state && that.$store.state.token) || '';
      if (!token) {
        let p = that;
        let showTostFn = null;
        while (p && !showTostFn) {
          if (typeof p.showTost === 'function') { showTostFn = p.showTost.bind(p); }
          else { p = p.$parent; }
        }
        if (showTostFn) { showTostFn(0, '请先登录'); }
        else {
          try { that.$notify({ type: 'warning', message: '请先登录' }); } catch (e) { alert('请先登录'); }
        }
        return;
      }
      const gameId = Number(item.game_id || item.id || 0);
      if (!gameId) {
        that.showT('缺少游戏ID');
        return;
      }
      // 乐观翻转 + 接口调用
      const oldVal = Number(item.is_favorite || 0);
      item.is_favorite = oldVal ? 0 : 1;
      that.$apiFun.gameFavoriteToggle({ game_id: gameId }).then(res => {
        if (res.code !== 200) {
          item.is_favorite = oldVal;
          that.showT(res.message || '操作失败');
          return;
        }
        const favorited = !!(res.data && res.data.favorited);
        item.is_favorite = favorited ? 1 : 0;
        // 轻量同步：手动增删 localStorage.favoriteList + setFavoriteList
        // 不调 changGameList（防止重置 hotList/游戏列表卡片导致 is_favorite 闪回）
        try {
          let curList = [];
          try {
            const local = localStorage.getItem('favoriteList');
            if (local) curList = JSON.parse(local) || [];
          } catch (e) {}
          if (favorited) {
            curList = curList.filter(el => Number(el.game_id || el.id) !== gameId);
            const favItem = {
              game_id: gameId,
              id: gameId,
              game_name: item.game_name || item.name || item.platform_name || '',
              game_code: String(item.game_code || ''),
              platform_name: item.platform_name || '',
              api_logo_img: item.api_logo_img || '',
              mobile_img: item.mobile_img || '',
              tag: item.tag || '',
              category_id: item.category_id || '',
              is_favorite: 1,
              is_hot: item.is_hot || 0,
            };
            curList.unshift(favItem);
          } else {
            curList = curList.filter(el => Number(el.game_id || el.id) !== gameId);
          }
          localStorage.setItem('favoriteList', JSON.stringify(curList));
          if (that.$store && typeof that.$store.commit === 'function') {
            that.$store.commit('setFavoriteList', curList);
          }
        } catch (e) {}
      }).catch(err => {
        item.is_favorite = oldVal;
        console.error('gameFavoriteToggle error:', err);
        that.showT('网络错误');
      });
    },
    showT(msg, type) {
      let that = this;
      let p = that, fn = null;
      while (p && !fn) { if (typeof p.showTost === 'function') fn = p.showTost.bind(p); else p = p.$parent; }
      if (fn) { fn(type === 0 ? 0 : 0, msg || ''); return; }
      try { that.$notify({ type: 'warning', message: msg }); } catch (e) { try { alert(msg); } catch (x) {} }
    },
    // 逐级查找父组件的方法，找不到走 notify 兜底
    callParent(methodName, ...args) {
      let p = this;
      while (p) {
        if (typeof p[methodName] === 'function') { return p[methodName].apply(p, args); }
        p = p.$parent;
      }
      return null;
    },
  },
  
}
</script>

<style lang="scss" scoped>
@import '../../static/css/common.css';
.list-page{min-height: 100vh;}
.nav-class{background-color: #292A2C;width: 2rem;}
.game-tabs{
    display: flex;
    padding: .2rem;
    border-radius: 0 0 .2rem .2rem;
    background-color: #292A2C;
    flex-wrap: wrap;
    .tab{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: calc((100% - 1.5rem) / 4);
        height: .90rem;
        line-height: 1;
        margin: .15rem;
        background-color: #1E1F24;
        border-radius: .2rem;
        border: .014rem solid #3B3C3D;
        color: #BEBEBE;
        text-align: center;
        font-size: .28rem;
        font-weight: 700;
        .tab-icon {
          width: 0.5rem;
          height: 0.5rem;
          margin-right: 0.08rem;
        }
    }
    .active{
        color: #703904;
        background-color: #d1ae52;
        border: .014rem solid #d1ae52;
        font-weight: 400;
    }
    
}

/* 左侧主游戏选项卡 + 右侧子游戏布局 */
.game-category-box {
  padding: 0 .2rem;
  margin-top: 0.2rem;
  min-height: calc(100vh - 46px - 0.2rem);
  .game-category-layout {
    display: flex;
    gap: 0.2rem;
  }
  .game-sidebar {
    width: 26.5%;
    flex-shrink: 0;
    .sidebar-item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.25rem 0.1rem;
      margin-bottom: 0.15rem;
      font-size: 0.3rem;
      color: #999;
      letter-spacing: 0.05rem;
      cursor: pointer;
      border-radius: 0.15rem;
      transition: all 0.3s;
      background: #323233;
      .sidebar-icon {
        width: .45rem;
        height: .45rem;
        margin-right: .08rem;
        border-radius: .08rem;
        flex-shrink: 0;
      }
      &.active {
        background: rgba(223, 179, 114, 0.1);
        color: #DFB372;
      }
    }
  }
  .game-content {
    flex: 1;
    overflow-y: auto;
    max-height: calc(100vh - 46px - 0.4rem);
    background: #1a1a1a;
    padding: 0.15rem;
    &::-webkit-scrollbar { display: none; }
    .game-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 0.15rem;
      .game-card {
        position: relative;
        border-radius: 0.1rem;
        overflow: hidden;
        cursor: pointer;
        img {
          width: 100%;
          display: block;
          border-radius: 0.35rem;
        }
        .game-card-collect {
          position: absolute;
          top: 0.1rem;
          right: 0.1rem;
          width: 0.5rem;
          height: 0.5rem;
          cursor: pointer;
        }
        .game-card-head {
          display: inline-block;
          width: 0.55rem;
          height: 0.5rem;
          vertical-align: middle;
          border-radius: 0;
          margin-right: 0.05rem;
        }
        .game-card-name {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          color: #f1f4fc;
          font-size: 0.28rem;
          white-space: nowrap;
          text-shadow: 0 0 4px rgba(0,0,0,0.8);
        }
        .game-card-label {
          position: absolute;
          top: 0.05rem;
          left: 0.05rem;
          background: rgba(223, 179, 114, 0.9);
          color: #000;
          font-size: 0.2rem;
          padding: 0.02rem 0.1rem;
          border-radius: 0.05rem;
        }
      }
    }
    .empty-tip {
      text-align: center;
      color: #666;
      font-size: 0.3rem;
      padding: 2rem 0;
    }
  }
}
</style>
<style scoped>
.nav-class /deep/ .van-popup{background-color: transparent;}
.nav-class /deep/ .van-dropdown-menu__bar{
    background-color: transparent!important;
}
.nav-class /deep/ .van-dropdown-menu__bar{
    height: auto!important;
}
.nav-class /deep/ .van-dropdown-menu__title{
    color: #fff!important;
    font-size: .6rem!important;
}
</style>



// WEBPACK FOOTER //
// src/components/gameList.vue